import {useState} from 'react';

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.currentTarget.value);
  };

  const handleManuallyChange = txt => {
    setValue(txt);
  };

  return {
    value,
    onChange: handleChange,
    manuallyChange: handleManuallyChange,
  };
};

export const usePagination = (array, perPage = 20) => {
  const [page, setPage] = useState(1);
  const count = Math.ceil(array.length / perPage);
  const onChange = (e, val) => {
    setPage(val);
  };
  const dataToShow = array.slice((page - 1) * perPage, page * perPage);

  return {
    count,
    page,
    onChange,
    dataToShow,
  };
};

export const getRoutePath = (location, params) => {
  const {pathname} = location;

  if (!Object.keys(params).length) {
    return pathname;
  }

  let path = pathname;
  Object.entries(params).forEach(([paramName, paramValue]) => {
    if (paramValue) {
      path = path.replace(paramValue, `:${paramName}`);
    }
  });
  return path;
};
